import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ContentElipsisPipe } from "./content-elipsis.pipe";
import { datePipe } from "./date.pipe";
import { DocumentCountPipe } from "./document-count.pipe";
import { EfficiencyPipe } from "./efficiency.pipe";
import { emptyValuePipe } from "./empty-value.pipe";
import { errorMessagePipe } from "./error-message.pipe";
import { FileSizePipe } from "./file-size.pipe";
import { nodataValuePipe } from "./no-data.pipe";
import { ReplaceUnderscorePipe } from "./replace-underscore.pipe";
import { StringFormatPipe } from "./string-format.pipe";

@NgModule({
  declarations: [
    errorMessagePipe,
    emptyValuePipe,
    datePipe,
    nodataValuePipe,
    EfficiencyPipe,
    FileSizePipe,
    ContentElipsisPipe,
    ReplaceUnderscorePipe,
    StringFormatPipe,
    DocumentCountPipe,
  ],
  imports: [CommonModule],
  exports: [
    errorMessagePipe,
    emptyValuePipe,
    datePipe,
    nodataValuePipe,
    EfficiencyPipe,
    FileSizePipe,
    ContentElipsisPipe,
    ReplaceUnderscorePipe,
    StringFormatPipe,
    DocumentCountPipe,
  ],
})
export class PipeModule {}

// nodataValuePipe,emptyValuePipe,EfficiencyPipe,datePipe
